export enum RuleEngineItemType {
  Group = 'group',
  Rule = 'rule'
}
